// 色域指定: サンプル色との距離からソフトなマスクを作る (純ロジック)。
import type { Rect } from '@/types/geometry'
import { trimMask, type MaskData } from './mask'

export interface ColorRangeOptions {
  /** サンプル色 (0..255) */
  r: number
  g: number
  b: number
  /** 許容量 0..200。距離がこの半分以下なら 255、以上で 0 へ線形 */
  fuzziness: number
  invert?: boolean
}

export function colorRange(rgba: Uint8ClampedArray, rect: Rect, o: ColorRangeOptions): MaskData | null {
  const n = rect.w * rect.h
  const data = new Uint8ClampedArray(n)
  const fz = Math.max(1, o.fuzziness)
  const lo = fz / 2
  for (let i = 0; i < n; i++) {
    const p = i * 4
    const a = rgba[p + 3]!
    if (a === 0) {
      data[i] = o.invert ? 255 : 0
      continue
    }
    const d = Math.max(Math.abs(rgba[p]! - o.r), Math.abs(rgba[p + 1]! - o.g), Math.abs(rgba[p + 2]! - o.b))
    let v = d <= lo ? 255 : d >= fz ? 0 : Math.round(255 * (1 - (d - lo) / (fz - lo)))
    v = Math.round((v * a) / 255)
    data[i] = o.invert ? 255 - v : v
  }
  return trimMask({ rect: { ...rect }, data })
}
